export default () => ({
    isOpen: false,
   
    open() {
        this.isOpen = true;
    },
    close() {
        this.isOpen = false;
    },
    toggle(open) {
        if (open) {
            this.isOpen = open.detail;
        }
    }
});